import React, { useState, useEffect } from 'react'
import axios from 'axios'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import Heading from '~components/Heading'
import Carousel from '~components/Carousel'
import BrandLink from '~components/BrandLink'
import Ribbon from '~components/Ribbon'
import { loadPage } from '~redux/content'
import Loader from '~components/Loader'
import { getOrderStatus } from '~helpers/main'
import { pageView } from '~helpers/ga'

const Confirmation = ({ content, loadPage }) => {
  const [orders, setOrders] = useState(false)
  const [pageContent, setPageContent] = useState('')

  const breadcrumbs = [{
    title: 'Basket',
    url: '/basket'
  }]

  useEffect(() => {
    pageView()
    loadPage('dashboard')
  }, [])

  useEffect(() => {
    axios.get('/api/account/orders/recent')
      .then(response => setOrders(response.data))

    axios.get('/options', {
      params: { option: 'confirmation_text' }
    }).then(response => {
      setPageContent(response.data.fields)
    })
  }, [])

  if (!content) {
    return <Loader />
  }

  return (
    <>
      <Heading
        breadcrumbs={breadcrumbs}
        title="Confirmation"
        className="mt-2 lg:mt-10"
      />

      <div className="px-4 mx-auto xxl:container md:px-8 xxl:px-0">
        <Ribbon
          status="success"
          text="Your order has been successfully submitted"
          link="/account"
          linkText="Go to account"
          className="mt-10"
        />
      </div>

      <div className="px-4 mx-auto my-10 xxl:container md:px-8 xxl:px-0 xl:my-20">
        <div className="flex flex-wrap items-stretch -mx-2 -my-5 lg:-mx-3 xxl:-mx-5">
          {orders && (
            <section className="w-full px-2 my-5 lg:px-3 lg:w-1/2 xxl:px-5">
              <h2 className="mb-5 md:mb-10">
                Order status
              </h2>

              <div className="w-full overflow-x-auto">
                <table className="w-full">
                  <tbody>
                    {orders.map((order, index) => {
                      const classes = []

                      if (index % 2 === 0) {
                        classes.push('bg-pink')
                      }

                      return (
                        <tr key={order.id}>
                          <td className={classNames('p-4 sm:p-6 xl:p-8', classes)}>
                            {order.id}
                          </td>

                          <td className={classNames('p-4 sm:p-6 xl:p-8 text-center', classes)}>
                            {moment(order.date_created).format('DD-MM-YYYY')}
                          </td>

                          <td className={classNames('p-4 sm:p-6 xl:p-8 text-right', classes)}>
                            {getOrderStatus(order.status)}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </section>
          )}

          {pageContent && (
            <div className="w-full px-2 my-5 lg:px-3 lg:w-1/2 xxl:px-5">
              <div className="flex flex-wrap -mx-1 -my-4 md:-mx-2 md:-my-3 xxl:-mx-5">
                <div className="w-full px-1 my-4 md:w-1/2 md:px-2 md:my-3 xxl:px-5">
                  <span className="block mb-5 md:mb-9">
                    {pageContent.left_title}
                  </span>

                  <div className="editor editor-standard">
                    <p>
                      {pageContent.left_content}
                    </p>
                  </div>
                </div>

                <div className="w-full px-1 my-4 md:w-1/2 md:px-2 md:my-3 xxl:px-5">
                  <span className="block mb-5 md:mb-9">
                    {pageContent.right_title}
                  </span>

                  <div className="editor editor-standard">
                    <p>
                      {pageContent.right_content}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="px-4 mx-auto my-10 xxl:container md:px-8 xxl:px-0 xl:my-20">
        <div className="flex flex-wrap items-stretch -mx-2 -my-5 lg:-mx-3 xxl:-mx-5">
          <section className="w-full px-2 my-5 lg:px-3 lg:w-1/2 xxl:px-5">
            <h2 className="mb-5 md:mb-10">
              Quick links
            </h2>

            <div className="flex flex-wrap -m-1 md:-mx-2 md:-my-3 lg:-mx-3 xxl:-mx-5 xxl:-my-5">
              {content.fields.quick_links.map((link, index) => (
                <div className="w-1/2 px-1 my-1 md:w-1/3 lg:w-1/2 xl:w-1/3 md:px-2 lg:px-3 md:my-3 xxl:px-5 xxl:my-5" key={index}>
                  <BrandLink
                    title={link.attributes.text}
                    image={{
                      src: link.attributes.image.lg,
                      alt: link.attributes.text
                    }}
                    url={link.attributes.link}
                  />
                </div>
              ))}
            </div>
          </section>

          <section className="w-full px-2 my-5 lg:px-3 lg:flex lg:flex-col lg:w-1/2 xxl:px-5">
            <h2 className="mb-5 md:mb-10">
              Media hub
            </h2>

            <Carousel
              items={content.fields.ctas}
              className="flex flex-grow w-full min-h-80 lg:min-h-66 lg:max-h-80"
            />
          </section>
        </div>
      </div>
    </>
  )
}

Confirmation.propTypes = {
  content: PropTypes.object,
  loadPage: PropTypes.func
}

const mapStateToProps = (state) => ({
  content: state.content.dashboard || null
})

const mapDispatchToProps = (dispatch) => ({
  loadPage: (page) => { dispatch(loadPage(page)) }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirmation)
